import { faPerson } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { Accordion, Col, Container, Row } from 'react-bootstrap'
import Search from '../Utilities/Search'
import CustomSelect from '../Utilities/CustomSelect'
import { useEffect, useState } from 'react'
import { MarketerDetailsVM } from '../../Structure/ViewModels/Marketer/MarketerDetailsVM'
import TraineeTransactionsTable from './TraineeTransactionsTable'
import { Router } from '../../Structure/Handlers/Router'
import EditMarketerInfo from './EditMarketerInfo'
import SalariesTable from './SalariesTable'
import { Globals } from '../../Structure/Globals/GlobalObs'
import { GeneralMethods } from '../../Structure/Handlers/GeneralMethods'

const MarketerDetails = (props:{id:string}) => {
    const [vm , setVm] = useState<{viewModel:MarketerDetailsVM}>({viewModel: new MarketerDetailsVM(props.id)})
    const control = vm.viewModel
    useEffect(()=>{
        control.subscribeUpdate(setVm)
        control.getCards()
    },[])


  return (
    <div className='h-100 p-0 m-0 w-100'>
        {control.Show(
    <Container>
        <Row className='pt-5 justify-content-between mx-0'>
            <Col lg={4}>
                <div className='d-flex flex-wrap pb-3'>
                    <h2 className='my-auto'>{control.Data?.name}</h2>
                    <div className='d-flex flex-wrap  flex-column justify-content-end px-3 '>
                        <div className='bill bill-II d-flex fw-bold'>
                            <FontAwesomeIcon icon={faPerson} fontSize={20} className='p-1' />
                            <span className='px-3 my-auto'>{control.Data?.trainees}</span>
                        </div>
                    </div>
                </div>
                <div className='d-flex'>
                    <h5> عمولة </h5>
                    <h5 className='px-3'> {control.Data?.commission} % </h5>
                </div>
            </Col>
            {
                Globals.auth.User?.permissions.some(a=>a.id=='20')?(
                <div className='py-3' onClick={()=>Router.OpenNormalPage(<EditMarketerInfo  id={control.Id}/>)}>
                    <button className='button-I btn-cl-I px-5 py-2'>تعديل البيانات</button>
                </div>
                ):(null)
            }
            {
                Globals.auth.User?.permissions.some(a=>a.id=='20')?(
                <div className='py-3'>
                    {
                        control.Data?.status=='active'?(
                            <button className='button-I btn-cl-I bg-danger px-5 py-2' onClick={()=>control.changeState('inActive')}>تعطيل</button>
                        ):(
                            <button className='button-I btn-cl-I bg-success px-5 py-2' onClick={()=>control.changeState('active')}>تفعيل</button>
                        )
                    }
                    
                </div>
                ):(null)
            }
        </Row>
        
        <Row className='py-5 justify-content-between w-100 mx-0'>
            <Col lg={12} className='d-flex flex-wrap fw-bold py-4 txt-gray'>
                <Row className='w-100 text-center mx-0'>
                    {
                        control.Data?.cards.map((item,index)=>(
                            <Col key={index} lg={4} className='p-lg-4 py-3'>
                                <div className='rounded-3 border '>
                                    <h5 className=' py-3'>
                                        {item.account}
                                    </h5>
                                    <div className='d-flex justify-content-between py-3'>
                                        <div className='w-100'>اجمالى</div>
                                        <div className='w-100'>
                                            {item.total_sales}
                                        </div>
                                    </div>
                                    <div className='d-flex justify-content-between py-3'>
                                        <div className='w-100'>الحالى</div>
                                        <div className='w-100'>
                                            {item.waiting_sales}
                                        </div>
                                    </div>
                                </div>
                            </Col>
                        ))
                    }
                </Row>
            </Col>
        </Row>
        <Row>
            <Col md='12' className=''>
                <div className='border rounded-2 p-3 d-flex flex-wrap'>
                    <h6 className='px-2 py-2'>الاسم : {control.Data?.name}</h6>
                    <h6 className='px-2 py-2'>الموبايل : +{control.Data?.dial_code} {control.Data?.mobile}</h6>
                    {control.Data?.email?(<h6 className='px-2 py-2'>الايميل : {control.Data.email}</h6>):(null)}
                    {control.Data?.bank_account?(<h6 className='px-2 py-2'>الحساب البنكي : {control.Data.bank_account}</h6>):(null)}
                </div>
            </Col>
        </Row>
        <div className='py-2 p-lg-4'>
            
            <Accordion>
                <Accordion.Item eventKey="1" className=' overflow-hidden' >
                    <Accordion.Header className='overflow-auto'>
                        <h4>حساب الراتب</h4>
                    </Accordion.Header>
                    <Accordion.Body className='px-0 px-lg-3'>
                        <Row className='px-0 py-2 p-lg-2 mx-0'>
                            <Row className='px-0 py-2 p-lg-2 mx-0'>
                                {
                                    control.Data?.cards.map((item,index)=>(Number(item.waiting_sales)?(
                                        <Col key={index} md={4} className='p-3'>
                                            <div className='border rounded-3 overflow-hidden'>
                                                <div className='d-flex'>
                                                    <h5 className='text-center w-100 rounded-bottom-5 p-1 text-white bg-I'>
                                                        {item.account}
                                                    </h5>
                                                </div>
                                                <div className='p-3'>
                                                    <div className='d-flex justify-content-between py-2'>
                                                        <div>القيمة</div>
                                                        <div>
                                                            {item.waiting_sales}
                                                        </div>
                                                    </div>
                                                    <div className='d-flex justify-content-between'>
                                                        <div className='py-2'>سعر العملة</div>
                                                        <div className='py-2'>
                                                            {item.price}
                                                        </div>
                                                    </div>
                                                    <div className='d-flex justify-content-between py-2'>
                                                        <h6>اجمالى</h6>
                                                        <h6>
                                                            {Math.ceil(Number(item.waiting_sales)*(Number(item.price))*100)/100}
                                                        </h6>
                                                    </div>
                                                </div>
                                            </div>
                                        </Col>):(null)
                                    ))
                                }
                            </Row>
                            <Row className='px-0 py-2 p-lg-2 pt-5 text-white mx-0'>
                                <Col md={4} className='p-3'>
                                    <div className='d-flex flex-column justify-content-around text-center rounded bg-I py-3  h-100'>
                                        <div className='d-flex justify-content-around'>
                                            <div className='py-2'>اجمالى</div>
                                            <div className='py-2'>
                                                {
                                                    control.SalaryData.sales
                                                }
                                            </div>
                                        </div>
                                        <div className='d-flex justify-content-around'>
                                            <div className='py-2'>النسبة</div>
                                            <div className='py-2'>{control.Data?.commission}</div>
                                        </div>
                                        <div className='d-flex justify-content-around'>
                                            <div className='py-2'>المستحق</div>
                                            <div className='py-2'>{control.SalaryData.deserved}</div>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={4} className='p-3 '>
                                    <div className='d-flex flex-column justify-content-around text-center rounded bg-I p-3  h-100'>
                                        <div className='d-flex justify-content-between'>
                                            <div className='py-2'>تارجت</div>
                                            <div className='py-2 d-flex'>
                                                <div className='my-auto'> {control.SalaryData.genTarget} </div>
                                                <div className='px-2 my-auto'> + </div>
                                                <div className='d-flex my-auto'> 
                                                    <input type="text" className='input-field py-1' value={control.SalaryData.target}  onChange={a=>control.Target=GeneralMethods.removeNonPositiveFloatNumeric(a.target.value)} style={{width:'60px'}} />    
                                                </div>
                                            </div>
                                        </div>
                                        <div className='d-flex justify-content-between'>
                                            <div className='py-2'>خصومات</div>
                                            <div className='py-2 d-flex'>
                                                <div className='my-auto'> {control.SalaryData.genCuts} </div>
                                                <div className='px-2 my-auto'> + </div>
                                                <div className='d-flex my-auto'> 
                                                    <input type="text" className='input-field py-1'  value={control.SalaryData.cut}  onChange={a=>control.Cuts=a.target.value}  style={{width:'60px'}} />    
                                                </div>
                                            </div>
                                        </div>
                                        <div className='d-flex justify-content-between'>
                                            <div className='py-2'>مكافآت</div>
                                            <div className='py-2 d-flex'>
                                                <div className='my-auto'> {control.SalaryData.genBounses} </div>
                                                <div className='px-2 my-auto'> + </div>
                                                <div className='d-flex my-auto'> 
                                                    <input type="text" className='input-field py-1'  value={control.SalaryData.bounus}  onChange={a=>control.Bounses=a.target.value}  style={{width:'60px'}} />    
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </Col>
                                <Col md={4} className='p-3'>
                                    <div className=' d-grid  text-center rounded bg-I p-3  h-100'>
                                        <h5>ملاحظات</h5>
                                        <textarea value={control.SalaryData.notes} onChange={a=>control.Notes=a.target.value} style={{resize:'none'}}></textarea>
                                    </div>
                                </Col>
                            </Row>
                            <div className='rounded-2 p-2 border-lg-1 d-flex flex-wrap justify-content-around mx-0 my-3'>
                                <div className='d-flex justify-content-around my-auto'>
                                    <div>{control.SalaryData.deserved}</div>
                                </div>
                                <div className='d-flex justify-content-around my-auto'>
                                    <div>+</div>
                                </div>
                                <div className='d-flex justify-content-around my-auto'>
                                    <div>{Number(control.SalaryData.genTarget)+Number(control.SalaryData.target)}</div>
                                </div>
                                <div className='d-flex justify-content-around my-auto'>
                                    <div>+</div>
                                </div>
                                <div className='d-flex justify-content-around my-auto'>
                                    <div>{Number(control.SalaryData.genBounses)+Number(control.SalaryData.bounus)}</div>
                                </div>
                                <div className='d-flex justify-content-around my-auto'>
                                    <div>-</div>
                                </div>
                                <div className='d-flex justify-content-around my-auto'>
                                    <div>{Number(control.SalaryData.genCuts)+Number(control.SalaryData.cut)}</div>
                                </div>
                                <div className='d-flex justify-content-around my-auto'>
                                    <div>=</div>
                                </div>
                                <div className='d-flex justify-content-around fw-bold my-auto'>
                                    <div>{control.SalaryData.finalSalary}</div>
                                </div>
                                {
                                    Globals.auth.User?.permissions.some(a=>a.id=='14')?(
                                        <div className='d-flex justify-content-around fw-bold py-4 py-lg-0'>
                                            {control.SalaryData.deserved?(<button className='button-I btn-cl-I p-2 px-5' onClick={()=>control.send()}>اعتماد</button>):(null)}
                                        </div>
                                    ):(null)
                                }
                            </div>
                        </Row>
                    </Accordion.Body>
                </Accordion.Item>
            </Accordion>
        </div>
        {
            Globals.auth.User?.permissions.some(a=>a.id=='15')?(
                <div className='py-2 p-lg-4'>
                    <SalariesTable id={control.Id} />
                </div>            
            ):(null)
        }
        <div className='py-2 p-lg-4'>
            <TraineeTransactionsTable id={control.Id} />
        </div>

    </Container>)}
    </div>
  )
}

export default MarketerDetails
